export default __webpack_public_path__ + "static/media/que-step5.2a3e278d.gif";